import { createRoot } from "react-dom/client";
// @ts-ignore
import * as Sentry from "@sentry/react";
// @ts-ignore
import { createBrowserRouter, RouterProvider, redirect } from "react-router";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "./index.css";
import NotLoginLayout from "./layouts/NotLoginLayout.tsx";
import Login from "./pages/Login/Login.tsx";
import LoginLayout from "./layouts/LoginLayout.tsx";
import Users from "./pages/Users/Users.tsx";
import UserDetail from "./pages/Users/Detail/UserDetail.tsx";
import FactoringList from "./pages/Factoring/List/FactoringList.tsx";
import FactoringDetail from "./pages/Factoring/Detail/FactoringDetail.tsx";
import FactoringImages from "./pages/Factoring/Image/FactoringImages.tsx";
import FactoringDetailImages from "./pages/Factoring/Detail/Image/FactoringDetailImages.tsx";
import InfoChangeRequests from "./pages/InfoChangeRequest/InfoChangeRequests.tsx";
import { AuthProvider, ProtectedRoute } from "./AuthProvider.tsx";

const router = createBrowserRouter([
  {
    index: true,
    loader: () => redirect("/login"),
  },
  {
    Component: NotLoginLayout,
    children: [
      {
        path: "login",
        children: [
          {
            index: true,
            Component: Login,
          },
        ],
      },
    ],
  },
  {
    element: (
      <AuthProvider>
        <ProtectedRoute />
      </AuthProvider>
    ),
    children: [
      {
        Component: LoginLayout,
        children: [
          {
            path: "users",
            children: [
              {
                index: true,
                Component: Users,
              },
              {
                path: ":userId/details",
                Component: UserDetail,
              },
            ],
          },
          {
            path: "factoring",
            children: [
              {
                index: true,
                Component: FactoringList,
              },
              {
                path: ":factoringId/images",
                Component: FactoringImages,
              },
              {
                path: ":factoringId/details",
                Component: FactoringDetail,
              },
              {
                path: ":factoringId/details/images",
                Component: FactoringDetailImages,
              },
            ],
          },
          {
            path: "changereq",
            Component: InfoChangeRequests,
          },
        ],
      },
    ],
  },
]);

const theme = createTheme({
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(90deg, #5e85b8, #cc6496)',
        },
      },
    },
  },
});

// Sentry.init({
//   dsn: import.meta.env.VITE_SENTRY_DSN,
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, // Capture 100% of the transactions
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, sample 100% of sessions where errors occur.
//
//   environment: import.meta.env.MODE,
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: true
// });

const root = document.getElementById("root");

// const option = {
//   // Callback called when an error is thrown and not caught by an ErrorBoundary.
//   onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
//     console.warn('Uncaught error', error, errorInfo.componentStack);
//   }),
//   // Callback called when React catches an error in an ErrorBoundary.
//   onCaughtError: Sentry.reactErrorHandler(),
//   // Callback called when React automatically recovers from errors.
//   onRecoverableError: Sentry.reactErrorHandler(),
// }

createRoot(root!).render(
  <>
    <CssBaseline />
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
    </ThemeProvider>
  </>,
);
